export interface IWaitlistImportResults {
    isMissingHeaders: boolean,
    items: IWaitlistImportItem[],
    invalidRows: IWaitlistImportInvalidRow[]
}

export interface IWaitlistImportItem {
    rowNumber: number,
    mrn: string,
    firstName: string,
    lastName: string,
    alias: string,
    email: string,
    birthDate: string,
    bloodType: string,
    address: string,
    city: string,
    state: string,
    postalCode: string,
    phoneNumber: string,
    height: string,
    weight: string,
    gender: string,
    recipientId: number,
    statusId: number,
    status: string,
    isInFile: boolean
}

export interface IWaitlistImportInvalidRow {
    rowIndex: number,
    messages: string[]
}